import React, { useState, useMemo } from "react";
import CloseIcon from "@mui/icons-material/Close";
import Statusicon from "../../../assets/Images/statusicon.svg";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import "./statusfilter.css";

const StatusFilter = ({
  onFilterChange,
  activeFilter,
  setActiveFilter,
  type = "default",
}) => {
  const [selectedStatus, setSelectedStatus] = useState("All");

  const isOpen = activeFilter === type;

  const handleToggle = () => {
    setActiveFilter(isOpen ? null : type);
  };

  const getHeadingTitle = () => type || "Select Filter";

  const handleStatusSelect = (status) => {
    setSelectedStatus(status);
    onFilterChange(status);
    setActiveFilter(null); // Close filter after selecting
  };

  const bbpsBillers = [
    { label: "All", value: "all" },
    { label: "Broadband Postpaid", value: "Broadband Postpaid" },
    { label: "Cable TV", value: "Cable TV" },
    { label: "Clubs and Associations", value: "Clubs and Associations" },
    { label: "Credit Card", value: "Credit Card" },
    { label: "DTH", value: "DTH" },
    { label: "Donation", value: "Donation" },
    { label: "Education Fees", value: "Education Fees" },
    { label: "Electricity", value: "Electricity" },
    { label: "FastTag", value: "FastTag" },
    { label: "Gas", value: "Gas" },
    { label: "Hospital", value: "Hospital" },
    { label: "Hospital and Pathology", value: "Hospital and Pathology" },
    { label: "Housing Society", value: "Housing Society" },
    { label: "Insurance", value: "Insurance" },
    { label: "LPG Gas", value: "LPG Gas" },
    { label: "Landline Postpaid", value: "Landline Postpaid" },
    { label: "Loan Repayment", value: "Loan Repayment" },
    { label: "Mobile Postpaid", value: "Mobile Postpaid" },
    { label: "Mobile Prepaid", value: "Mobile Prepaid" },
    { label: "Municipal Services", value: "Municipal Services" },
    { label: "Municipal Taxes", value: "Municipal Taxes" },
    { label: "NCMC Recharge", value: "NCMC Recharge" },
    { label: "National Pension System", value: "National Pension System" },
    { label: "Prepaid Meter", value: "Prepaid Meter" },
    { label: "Recurring Deposit", value: "Recurring Deposit" },
    { label: "Rental", value: "Rental" },
    { label: "Subscription", value: "Subscription" },
    { label: "Water", value: "Water" },
  ];

  const statusOptions = useMemo(() => {
    let list = [];
    switch (type) {
      case "LinkStatus":
        return [
          { label: "All", value: "all" },
          { label: "Success", value: "success" },
          { label: "Expired", value: "Expired" },
          { label: "Processing", value: "processing" },
          { label: "Active", value: "Active" },
          { label: "Failed", value: "failed" },
        ];
      case "Status":
        return [
          { label: "All", value: "all" },
          { label: "Success", value: "success" },
          { label: "Failed", value: "failed" },
          { label: "Processing", value: "processing" },
          { label: "Reversed", value: "reversed" },
        ];
      case "settlements":
        return [
          { label: "All", value: "all" },
          { label: "Credited", value: "credited" },
          { label: "Pending", value: "pending" },
          { label: "Rejected", value: "rejected" },
        ];
      case "PaymentStatus":
        return [
          { label: "All", value: "all" },
          { label: "Success", value: "success" },
          { label: "Processing", value: "processing" },
          { label: "Failed", value: "failed" },
        ];
      case "PaymentMethod":
        return [
          { label: "All", value: "all" },
          { label: "UPI", value: "upi" },
          { label: "Credit Card", value: "credit_card" },
          { label: "Corporate Credit Card", value: "corporate_credit_card" },
          { label: "Debit Card", value: "debit_card" },
          { label: "Net Banking", value: "net_banking" },
        ];
      case "TransactionType":
        return [
          { label: "All", value: "all" },
          { label: "Credit", value: "credit" },
          { label: "Debit", value: "debit" },
        ];
      case "Rental":
        list = [
          { label: "All", value: "all" },
          { label: "House Rent", value: "House Rent" },
          { label: "Maintenance", value: "Maintenance" },
          { label: "Office Rent", value: "Office Rent" },
          { label: "Brokerage", value: "Brokerage" },
          { label: "Security Deposit", value: "Security Deposit" },
          { label: "Token Amount", value: "Token Amount" },
        ];
        return list;

      case "Educational":
        list = [
          { label: "All", value: "all" },
          { label: "Tuition Fee", value: "Tuition Fee" },
          { label: "School Fee", value: "School Fee" },
          { label: "College Fee", value: "College Fee" },
        ];
        return list;

      case "Vendors":
        list = [
          { label: "All", value: "all" },
          { label: "Vendor Payments", value: "Vendor Payments" },
        ];
        return list;

      case "BBPS":
        return bbpsBillers

      case "Settlements":
        return [
          { label: "All", value: "all" },
          { label: "Bill", value: "Top_Up" },
          { label: "NU 1", value: "PRO[T+1]" },
          { label: "Pro (T+0)", value: "PRO[T+0]" },
          { label: "Edu", value: "PRO[INSTANT]" },
          { label: "Bill Plus", value: "BILL[PRO]" },
          { label: "Transfer", value: "Transfer" },
          { label: "PayOut_Settlements", value: "PayOut_Settlements" },
        ];
      case "PaymentofStatus":
        return [
          { label: "All", value: "all" },
          { label: "Active", value: "active" },
          { label: "Deactive", value: "deactive" },
        ];
      case "PaymentStatu's":
        return [
          { label: "All", value: "all" },
          { label: "Success", value: "success" },
          { label: "Processing", value: "processing" },
        ];
      case "TypeofPayments":
        return [
          { label: "All", value: "all" },
          { label: "Settlements", value: "settlements" },
          { label: "BBPS", value: "bbps" },
          { label: "Rental", value: "rental" },
          { label: "Educational", value: "educational" },
          { label: "Vendors", value: "vendors" },
        ];
      default:
        return [
          { label: "All", value: "all" },
          { label: "Success", value: "success" },
          { label: "Failed", value: "failed" },
        ];
    }
  }, [type]);

  return (
    <div className="filter-dropdown-container-history-v">
      <button className="filter-button-history-v" onClick={handleToggle}>
        <img className="category-icon" src={Statusicon} alt="status" />
        {selectedStatus === "All" ? type : selectedStatus}
        <ArrowDropDownIcon />
      </button>

      {isOpen && (
        <div className="status-dropdown-v">
          <div className="dropdown-header-v">
            <h3>{getHeadingTitle()}</h3>
            <button
              className="close-button-settlement"
              onClick={() => setActiveFilter(null)}
            >
              <CloseIcon />
            </button>
          </div>

          <div className="status-options-v">
            {statusOptions.map((option) => (
              <div key={option.value} className="status-option-v">
                <label className="radio-label-v">
                  <input
                    type="radio"
                    name="status"
                    value={option.value}
                    checked={selectedStatus === option.label}
                    onChange={() => handleStatusSelect(option.label)}
                  />
                  <span className="radio-text-v">{option.label}</span>
                </label>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default StatusFilter;




